import { render, staticRenderFns } from "./articleBody.vue?vue&type=template&id=d5a3fa72&scoped=true&lang=html&"
import script from "./articleBody.vue?vue&type=script&lang=js&"
export * from "./articleBody.vue?vue&type=script&lang=js&"
import style0 from "./articleBody.vue?vue&type=style&index=0&id=d5a3fa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a3fa72",
  null
  
)

export default component.exports